module.exports = __webpack_public_path__ + "img/yue.d4939167.svg";